import $ from 'jquery';
import BalloonClass from '../common/BalloonClass';

/**
 * キャンセルポリシーのバルーン
 */
export default class CancelPolicyBalloonClass extends BalloonClass {
  constructor() {
    super();
    this.name = 'CancelPolicyBalloonClass';
    this.balloonSelector = '.css_balloon.cancel_policy';
    this.clickSelector = '.js-balloon_cancelpolicy';
  }

  onOpen(_target) {
    const text = _target.attr('data-text');
    $('p', this.balloon).text(text);
    super.onOpen(_target);
  }

  positionSet(_target) {
    const offset = _target.offset();

    let top = offset.top - this.balloon.outerHeight(true);
    let left = offset.left + _target.width() / 2;

    let match = document.getElementById('travelko');
    if(match !== null){
       top = top + 110;
    }

    // if(Util.isBreakpoint) left = "";
    this.balloon.css({ top: top, left: left });
  }
}
